<template>
	<Teleport to="body">
		<Transition
			enter-active-class="transition duration-300 ease-out"
			enter-from-class="opacity-0"
			enter-to-class="opacity-100"
			leave-active-class="transition duration-300 ease-in"
			leave-from-class="opacity-100"
			leave-to-class="opacity-0"
		>
			<div
				v-show="showModal"
				ref="modal-backdrop"
				class="prose fixed inset-0 z-[1000] max-w-none overflow-hidden overflow-y-auto bg-gray-500/50 antialiased"
			>
				<div
					class="flex h-screen items-center justify-center text-left"
				>
					<div
						ref="modal"
						class="flex h-full w-full flex-wrap"
						role="dialog"
						aria-modal="true"
						aria-labelledby="modal-headline"
					>
						<div
							class="absolute h-screen w-screen"
							@click="closeModal"
						/>
						<div
							class="m-auto flex max-h-max w-11/12 transform-gpu flex-col rounded-md drop-shadow-lg transition-all delay-300 duration-500"
							:class="[
								isCustom
									? 'md:w-fit md:max-w-[600px]'
									: 'p-2 sm:p-4',
								customSize,
								customPadding,
								customHeight,
								bgColor,
							]"
						>
							<div
								class="flex-col"
								:class="[innerBgColor, innerPadding]"
							>
								<div class="flex justify-end">
									<div
										class="cursor-pointer"
										@click="closeModal"
									>
										<IconTimes
											class="text-gray-700 transition-all ease-in-out hover:text-blue-400"
										/>
									</div>
								</div>
								<div>
									<slot
										name="contentArea"
										:close-modal="closeModal"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Transition>
	</Teleport>
</template>

<script setup>
import IconTimes from '@/assets/svg/common/ico-times.svg'

const showModal = ref(false)

const props = defineProps({
	show: {
		type: Boolean,
		default: false,
	},
	isFormModalActivated: {
		type: Boolean,
		default: false,
	},
	isCustom: {
		type: Boolean,
		default: false,
	},
	innerBgColor: {
		type: String,
		default: '',
	},
	innerPadding: {
		type: String,
		default: '',
	},
	customSize: {
		type: String,
		default: '',
		required: false,
	},
	customPadding: {
		type: String,
		default: 'p-2 md:p-4',
		required: false,
	},
	customHeight: {
		type: String,
		default: '',
		required: false,
	},
	bgColor: {
		type: String,
		default: 'bg-white',
		required: false,
	},
	showCloseButton: {
		type: Boolean,
		default: false,
		required: false,
	},
})

const closeModal = () => {
	if (props.isFormModalActivated) {
		showModal.value = false
	} else {
		showModal.value = false
		emit('modalState', showModal.value)
		emit('closeModal')
		document.body.classList.remove(...['disable-scroll'])
	}
}

watch(
	() => props.show,
	() => {
		showModal.value = true
		document.body.classList.add(...['disable-scroll'])
	}
)

const emit = defineEmits(['modalState', 'closeModal'])

defineExpose({ closeModal })
</script>
